import { container, primaryColor } from "../../../../assets/jss/material-kit-react.jsx"

const footerStyle = {
    container: {
        ...container,
        backgroundColor: "#2D3C48",
        lineHeight: 1,
        // "@media (max-width: 600px)": {
        //   backgroundColor: "#bada55",
        // },
    },
    block: {
        color: "#BDBDBD",
        padding: "0.9375rem",
        fontWeight: "600",
        fontSize: "12px",
        textTransform: "uppercase",
        borderRadius: "3px",
        textDecoration: "none",
        position: "relative",
        display: "block",
    },
    left: {
        float: "left!important",
        display: "block",
    },
    right: {
        padding: "15px 0",
        margin: "0",
        float: "right!important",
    },
    footer: {
        padding: "3.9375rem 0",
        textAlign: "center",
        display: "flex",
        zIndex: "2",
        fontFamily: "Open Sans",
        position: "relative",
    },
    footerSecond: {
        padding: "1.5rem 0",
        textAlign: "center",
        display: "flex",
        zIndex: "2",
        fontFamily: "Open Sans",
        position: "relative",
    },
    a: {
        color: primaryColor,
        textDecoration: "none",
        backgroundColor: "transparent",
    },
    footerWhiteFont: {
        "&,&:hover,&:focus": {
            color: "#FFFFFF",
        },
    },
    linkFooter: {
        textDecoration: "none",
        "&:hover,&:focus": {
            textDecoration: "underline",
        },
    },
    list: {
        marginBottom: "0",
        padding: "0",
        marginTop: "0",
        color: "#BDBDBD",
    },
    inlineBlock: {
        display: "inline-block",
        padding: "0px",
        width: "auto",
    },
    icon: {
        width: "18px",
        height: "18px",
        position: "relative",
        top: "3px",
    },
}
export default footerStyle



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/components/footerStyle.jsx